import axios from 'axios'
import store from '@/store'

const api2 = axios.create({
  // Use empty string for relative URLs (goes through nginx proxy)
  baseURL: '',
  //baseURL: 'https://signature-checker2.etsi.org',
  headers: {
    //'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})



// ... rest of the code remains the same

api2.interceptors.request.use(
  (config) => {
    const token = store.state.auth.accessToken
    
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
   
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

api2.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true
      try {
        await store.dispatch('auth/refreshToken')
        return api2(originalRequest)
      } catch (refreshError) {
        store.dispatch('auth/logout')
        return Promise.reject(refreshError)
      }
    }
    return Promise.reject(error)
  }
)

export default api2

